import { createContext } from 'react';
import { Page } from '../../types/Types';
import FacebookPageHooks from './FacebookPage.hooks';

export const FacebookPageContext = createContext({
  pageState: {
    pages: [{} as Page],
    isLoading: false,
    errMessage: '',
  },
  fetchPages: (type: string, status: string) => {},
  uploadPages: (param: []) => {},
  editPage: (param: Page) => {},
  deletePage: (paramId: string) => {},
  deleteManyPages: (paramId: []) => {},
  editManyPages: (paramId: [], param: Page) => {},
  editStockAgent: (paramId: [], param: Page) => {},
  fetchPageByDate: (startDate: Date, endDate: Date) => {},
});

export function FacebookPageProvider(props: any) {
  const {
    state,
    fetchPages,
    uploadPages,
    editPage,
    deletePage,
    deleteManyPages,
    editManyPages,
    editStockAgent,
    fetchPageByDate,
  } = FacebookPageHooks();

  return (
    <FacebookPageContext.Provider
      value={{
        pageState: state,
        uploadPages,
        editPage,
        deletePage,
        deleteManyPages,
        editManyPages,
        editStockAgent,
        fetchPages,
        fetchPageByDate,
      }}
    >
      {props.children}
    </FacebookPageContext.Provider>
  );
}
